import Compressor from "compressorjs";
import PassportImage from '../../Assets/images/passport.svg'
import React, { useState } from "react";
import DatePicker from "react-multi-date-picker";
import { toast } from "react-toastify";
import moment from "moment";
import Handler from '../../Helpers/Handler'
import { reloadWindow } from '../../Helpers/Utils'

const Passport = ({ requestKey }) => {
    const [loading, setLoading] = useState(false)
    const [details, setDetails] = useState({})
    const verifyPassport = async () => {
        if (!details?.passportFrontPage) {
            toast.error('Passport Seal Photo Required')
        } else if (!details?.passportBackPage) {
            toast.error('Passport File Number Page Required')
        } else if (!details?.passportSealPhoto) {
            toast.error('Passport Signature Page Required')
        } else if (!details?.passport) {
            toast.error('Invalid Passport File No')
        } else if (!details?.passportName) {
            toast.error('Invalid Passport Name')
        } else if (!details?.passportDate) {
            toast.error('Passport Validupto Required')
        } else {
            setLoading(true)
            const data = new FormData()
            data?.append('passport', details?.passport || "")
            data?.append('passportName', details?.passportName || "")
            data?.append('passportFrontPage', details?.passportFrontPage || "")
            data?.append('passportBackPage', details?.passportBackPage || "")
            data?.append('passportSealPhoto', details?.passportSealPhoto || "")
            data?.append('passportDate', details?.passportDate || "")
            data?.append('dob', details?.dob || "")
            const response = await Handler({ method: 'PATCH', url: `/customer/passport/verify/${requestKey}`, data, formData: true })
            if (response?.success) {
                toast.success(response?.message);
                setTimeout(() => {
                    reloadWindow();
                    setLoading(false)
                }, 1500);
            } else {
                setLoading(false)
                toast.error(response?.message)
            }
        }
    }
    const handleChange = (e) => {
        setDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const compressImage = (file, name) => {
        new Compressor(file, {
            quality: 0.6,
            maxWidth: 800,
            maxHeight: 600,
            success(result) {
                if (result.size > 4.5 * 1024 * 1024) {
                    toast.error('Compressed image size exceeds 4.5 MB.');
                } else {
                    storeFile(result, name)
                }
            },
            error(err) {
                toast.error(err.message);
            },
        });
    }
    const storeFile = (file, name) => {
        if (name === 'passportFrontPage') {
            setDetails((prev) => ({ ...prev, passportFrontPage: file, passportPhoto1: URL.createObjectURL(file) }))
        }
        if (name === 'passportBackPage') {
            setDetails((prev) => ({ ...prev, passportBackPage: file, passportPhoto2: URL.createObjectURL(file) }))
        }
        if (name === 'passportSealPhoto') {
            setDetails((prev) => ({ ...prev, passportSealPhoto: file, passportPhoto3: URL.createObjectURL(file) }))
        }
    }
    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            if (e.target.files[0]?.size > 4.5 * 1024 * 1024) {
                compressImage(e.target.files[0], [e.target.name]);
            } else {
                storeFile(e.target.files[0], e.target.name)
            }
        }
    }
    return (
        <React.Fragment>
            <div className="row justify-content-center pt-3 px-4">
                <div className="col-xs-12 col-md-5" >
                    <div className="mb-3 d-flex justify-content-center align-items-center proof-form" >
                        <div className="proof-form-overlay"></div>
                        <div className="proof-overlay ">
                            <label tag={'label'} htmlFor='passportFrontPage' disabled={loading} className={`btn ${details?.passportStatus ? "d-none" : ''} me-2`} >Upload</label>
                        </div>
                        <div className="text-center">
                            {
                                details?.passportPhoto1 ?
                                    <div className="img-div">
                                        <img className="document" src={details?.passportPhoto1} alt="profile-image" width={500} height={500} />
                                    </div>
                                    :
                                    <div className="aadhaar-front">
                                        <i className="bi bi-cloud-arrow-up-fill"></i> Upload Passport Sealed Front Page
                                    </div>

                            }
                        </div>
                        <input disabled={loading} id="passportFrontPage" accept="image/*" className="document d-none" type="file" name="passportFrontPage" onChange={handleFileChange} />
                    </div>
                </div>
                <div className="col-xs-12 col-md-5" >
                    <div className="mb-3 d-flex justify-content-center align-items-center proof-form">
                        <div className="proof-form-overlay"></div>
                        <div className="proof-overlay ">
                            <label tag={'label'} htmlFor='passportBackPage' disabled={loading} className={`btn ${details?.passportStatus ? "d-none" : ''} me-2`} >Upload</label>
                        </div>
                        <div className="text-center">
                            {
                                details?.passportPhoto2 ?
                                    <div className="img-div">
                                        <img className="document" src={details?.passportPhoto2} alt="profile-image" width={500} height={500} />
                                    </div>
                                    :
                                    <div className="aadhaar-front">
                                        <i className="bi bi-cloud-arrow-up-fill"></i> Upload File Number Page
                                    </div>

                            }
                        </div>
                        <input disabled={loading} id="passportBackPage" accept="image/*" className="d-none" type="file" name="passportBackPage" onChange={handleFileChange} />
                    </div>
                </div>
                <div className="col-xs-12 col-md-5" >
                    <div className="mb-3 d-flex justify-content-center align-items-center proof-form">
                        <div className="proof-form-overlay"></div>
                        <div className="proof-overlay ">
                            <label tag={'label'} htmlFor='passportSealPhoto' disabled={loading} className={`btn ${details?.passportStatus ? "d-none" : ''} me-2`} >Upload</label>
                        </div>
                        <div className="text-center">
                            {
                                details?.passportPhoto3 ?
                                    <div className="img-div">
                                        <img className="document" src={details?.passportPhoto3} alt="profile-image" width={500} height={500} />
                                    </div>
                                    :
                                    <div className="aadhaar-front">
                                        <i className="bi bi-cloud-arrow-up-fill"></i> Upload Signature File Number Page
                                    </div>

                            }
                        </div>
                        <input disabled={loading} id="passportSealPhoto" accept="image/*" className="d-none" type="file" name="passportSealPhoto" onChange={handleFileChange} />
                    </div>
                </div>
            </div>
            <div className="row justify-content-center align-items-center mt-4 mb-3 px-4">
                <div className="col-md-6 col-xs-12">
                    <div className="text-center">
                        <img className="aadhaar-img" src={PassportImage} alt="Passport" />
                    </div>
                </div>
                <div className="col-md-6 col-xs-12">
                    <div className="mb-3">
                        <label className="form-label">Passport File Number</label>
                        <input autoComplete="off" type='text' disabled={loading} name="passport" className="form-control" placeholder=" Ex : MN09808986B0988" value={details?.passport || ""} onChange={handleChange} />

                    </div>
                    <div className="mb-3">
                        <label className="form-label">Passport Name</label>
                        <input autoComplete="off" type='text' disabled={loading} className="form-control" name="passportName" placeholder=" Ex : As per Passport" value={details?.passportName || ""} onChange={handleChange} />
                    </div>
                    <div className="mb-3 d-flex flex-column">

                        <label className="form-label">DOB </label>
                        <DatePicker
                            disabled={loading}
                            format={'DD-MM-YYYY'}
                            className="calender-theme"
                            inputClass="form-control"
                            placeholder="Ex : 28-12-2001"
                            value={details?.dob}
                            onChange={(date) => setDetails((prev) => ({ ...prev, dob: moment(date?.toDate()).format("DD-MM-YYYY") }))} />

                    </div>
                    <div className="mb-3 d-flex flex-column">

                        <label className="form-label">Passport Valid Upto </label>
                        <DatePicker
                            disabled={loading}
                            format={'DD-MM-YYYY'}
                            className="calender-theme"
                            inputClass="form-control"
                            placeholder="Ex : 29/12/2035"
                            value={details?.passportDate}
                            minDate={(new Date()).setMonth(((new Date()).getMonth()) + 1)}
                            onChange={(date) => setDetails((prev) => ({ ...prev, passportDate: moment(date?.toDate()).format("DD-MM-YYYY") }))} />

                    </div>
                    <div className="text-center">
                        <button className="btn btn-success" onClick={verifyPassport} disabled={loading}>{loading ? "Verifying..." : "Submit"}</button>
                    </div>
                </div>

            </div>
        </React.Fragment>
    )
}

export default Passport